import React, { useEffect, useState } from "react";
import { FormLabel, Stack } from "@mui/material";
import { notification, Select } from "antd";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { publishEvent } from "../../../components/generic/EventPublisher";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";

const SelectForm = ({ formType, configKey, organizationIdentifier, forms }) => {
  const user = useReadMemory(MemoryType.USER)
  const [selectedForm, setSelectedForm] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = async (value) => {
    setLoading(true);
    setSelectedForm(value);
    const configurationValue = { templateCode: value };
    const payload = {
      intent: "add_configuration",
      payload: {
        configurationKey: configKey,
        configurationValue: JSON.stringify(configurationValue),
      },
      context: {
        organizationIdentifier,
      },
    };

    try {
      const response = await performPostRequest(
        getApiUrl()[IntentType.ADD_CONFIGURATION],
        JSON.stringify(payload)
      );
      const result = await response.json();
      const parsedResult = JSON.parse(result?.configurationValue || "{}")
      publishEvent("niramaya.organization.defaultform.updated", user, parsedResult, { templateCode: selectedForm })
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchInitialValue = async () => {
      const payload = {
        intent: "get_configuration",
        payload: {
          configurationKey: [configKey],
        },
        context: {
          organizationIdentifier,
        },
      };

      try {
        const response = await performPostRequest(
          getApiUrl()[IntentType.GET_CONFIGURATION],
          JSON.stringify(payload)
        );
        const result = await response.json();
        const { templateCode } = JSON.parse(
          result[0]?.configurationValue || "{}"
        );

        setSelectedForm(templateCode);
      } catch (error) {
        notification.error({
          message: "Error while getting form template",
          placement: "bottomRight",
        });
      }
    };

    fetchInitialValue();
  }, [configKey, organizationIdentifier]);

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <FormLabel>{formType}</FormLabel>
        <Select
          style={{ width: 280 }}
          showSearch
          className="default-form-select"
          loading={loading}
          value={selectedForm}
          placeholder="Select Form"
          optionFilterProp="children"
          onChange={handleChange}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={forms}
        />
      </Stack>
    </>
  );
};

export default SelectForm;
